import { ACTORS, DIRECTORS, MOVIE_QUESTIONS } from './catalog';

export function shuffle(items) {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
}

function pickDistinct(pool, n) {
  return shuffle(pool).slice(0, n);
}

function personQuestions(people, category, prompt) {
  return people.map((person) => {
    const regional = people.filter(
      (p) => p.id !== person.id && p.region === person.region && p.gender === person.gender
    );
    const fallback = people.filter((p) => p.id !== person.id);
    const source = regional.length >= 3 ? regional : fallback;
    const distractors = pickDistinct(source, 3).map((p) => ({ ar: p.ar, en: p.en }));
    const answer = { ar: person.ar, en: person.en };
    return {
      id: `${category}-${person.id}`,
      category,
      image: person.file,
      frame: 'portrait',
      prompt: prompt(person.gender),
      answer,
      options: [answer, ...distractors],
      fact: person.fact,
    };
  });
}

function actorBank() {
  return personQuestions(ACTORS, 'actors', (gender) =>
    gender === 'f'
      ? { ar: 'من هذه الممثلة؟', en: 'Who is this actress?' }
      : { ar: 'من هذا الممثل؟', en: 'Who is this actor?' }
  );
}

function directorBank() {
  return personQuestions(DIRECTORS, 'directors', () => ({
    ar: 'من هذا المخرج؟',
    en: 'Who is this director?',
  }));
}

function poolFor(category) {
  if (category === 'actors') return actorBank();
  if (category === 'directors') return directorBank();
  if (category === 'movies') return MOVIE_QUESTIONS;
  return [...actorBank(), ...directorBank(), ...MOVIE_QUESTIONS];
}

export function buildRound(category, count) {
  const pool = poolFor(category);
  return shuffle(pool)
    .slice(0, Math.min(count, pool.length))
    .map((question) => {
      const shuffled = shuffle(question.options);
      return {
        ...question,
        shuffled,
        correctKey: question.answer.en,
      };
    });
}

export function rankFor(score, total, lang) {
  const ratio = total === 0 ? 0 : score / total;
  if (ratio >= 0.9) return lang === 'ar' ? 'أسطورة الشاشة' : 'Screen legend';
  if (ratio >= 0.7) return lang === 'ar' ? 'ناقد محترف' : 'Seasoned critic';
  if (ratio >= 0.5) return lang === 'ar' ? 'متفرج نهم' : 'Avid viewer';
  return lang === 'ar' ? 'تذكرة أولى' : 'First ticket';
}

export const OPTION_MARK = {
  ar: ['ألف', 'باء', 'جيم', 'دال'],
  en: ['A', 'B', 'C', 'D'],
};
